/**
 * ListingGrid
 * 
 * @Author: Focci
 * @Date: 2023-08-05 17:22:30
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-05 17:22:30
 */

import clsx from 'clsx'
import PropTypes from 'prop-types'
import ListingsSkeleton from './ListingsSkeleton'

export default function ListingGrid({
  isLoading = false,
  loadingCount,
  wrapperClassName = 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4',
  children
}) {
  return (
    <div className={clsx(['grid gap-4 mt-3', wrapperClassName])}>
      {(isLoading) && <ListingsSkeleton count={loadingCount} />}
      {!isLoading && children}
    </div>
  )
}

ListingGrid.propTypes = {
  isLoading: PropTypes.bool,
  loadingCount: PropTypes.number,
  wrapperClassName: PropTypes.string,
}
